import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import GlobalLoader from "../components/ui/loaders/GlobalLoader";
import { useAddBookMutation } from "../features/api/apiSlice";

const AddBook = () => {
    const navigate = useNavigate();
    const [addBook, { isLoading, isSuccess }] = useAddBookMutation();
    const [state, setState] = React.useState({
        name: "",
        author: "",
        thumbnail: "",
        price: "",
        rating: "",
        featured: false,
    });
    const handleSubmit = (e) => {
        e.preventDefault();
        addBook(state);
        setState({
            name: "",
            author: "",
            thumbnail: "",
            price: "",
            rating: "",
            featured: false,
        });
    };
    useEffect(() => {
        if (isSuccess) {
            navigate("/");
        }
    }, [isSuccess, navigate]);

    if (isLoading) {
        return <GlobalLoader />;
    }

    return (
        <main className="py-6 2xl:px-6">
            <div className="container">
                <div className="p-8 overflow-hidden bg-white shadow-cardShadow rounded-md max-w-xl mx-auto">
                    <h4 className="mb-8 text-xl font-bold text-center">
                        Add New Book
                    </h4>
                    <form className="book-form" onSubmit={handleSubmit}>
                        <div className="space-y-2">
                            <label htmlFor="lws-bookName">Book Name</label>
                            <input
                                required
                                className="text-input"
                                type="text"
                                id="lws-bookName"
                                name="name"
                                value={state.name}
                                onChange={(e) => {
                                    setState({
                                        ...state,
                                        name: e.target.value,
                                    });
                                }}
                            />
                        </div>
                        <div className="space-y-2">
                            <label htmlFor="lws-author">Author</label>
                            <input
                                required
                                className="text-input"
                                type="text"
                                id="lws-author"
                                name="author"
                                value={state.author}
                                onChange={(e) => {
                                    setState({
                                        ...state,
                                        author: e.target.value,
                                    });
                                }}
                            />
                        </div>
                        <div className="space-y-2">
                            <label htmlFor="lws-thumbnail">Image Url</label>
                            <input
                                required
                                className="text-input"
                                type="text"
                                id="lws-thumbnail"
                                name="thumbnail"
                                value={state.thumbnail}
                                onChange={(e) => {
                                    setState({
                                        ...state,
                                        thumbnail: e.target.value,
                                    });
                                }}
                            />
                        </div>
                        <div className="grid grid-cols-2 gap-8 pb-4">
                            <div className="space-y-2">
                                <label htmlFor="lws-price">Price</label>
                                <input
                                    required
                                    className="text-input"
                                    type="number"
                                    id="lws-price"
                                    name="price"
                                    value={state.price}
                                    onChange={(e) => {
                                        setState({
                                            ...state,
                                            price: e.target.value,
                                        });
                                    }}
                                />
                            </div>
                            <div className="space-y-2">
                                <label htmlFor="lws-rating">Rating</label>
                                <input
                                    required
                                    className="text-input"
                                    type="number"
                                    id="lws-rating"
                                    name="rating"
                                    min={1}
                                    max={5}
                                    value={state.rating}
                                    onChange={(e) => {
                                        setState({
                                            ...state,
                                            rating: parseInt(e.target.value),
                                        });
                                    }}
                                />
                            </div>
                        </div>
                        <div className="flex items-center">
                            <input
                                id="lws-featured"
                                type="checkbox"
                                name="featured"
                                className="w-4 h-4"
                                checked={state.featured}
                                onChange={(e) => {
                                    setState({
                                        ...state,
                                        featured: e.target.checked,
                                    });
                                }}
                            />
                            <label
                                htmlFor="lws-featured"
                                className="ml-2 text-sm"
                            >
                                This is a featured book
                            </label>
                        </div>
                        <button
                            type="submit"
                            className="submit"
                            id="lws-submit"
                        >
                            Add Book
                        </button>
                    </form>
                </div>
            </div>
        </main>
    );
};

export default AddBook;
